const r = {
  "cdr-popup": "cdr-popup_16-2-1",
  "cdr-popup--open": "cdr-popup--open_16-2-1",
  "cdr-popup--closed": "cdr-popup--closed_16-2-1",
  "cdr-popup__content": "cdr-popup__content_16-2-1",
  "cdr-popup__arrow": "cdr-popup__arrow_16-2-1",
  "cdr-popup--top": "cdr-popup--top_16-2-1",
  "cdr-popup--bottom": "cdr-popup--bottom_16-2-1",
  "cdr-popup--exit": "cdr-popup--exit_16-2-1",
  "cdr-popup--corner-left": "cdr-popup--corner-left_16-2-1",
  "cdr-popup--corner-right": "cdr-popup--corner-right_16-2-1",
  "cdr-popup--left": "cdr-popup--left_16-2-1",
  "cdr-popup--right": "cdr-popup--right_16-2-1",
  "cdr-popup--corner-top": "cdr-popup--corner-top_16-2-1",
  "cdr-popup--corner-bottom": "cdr-popup--corner-bottom_16-2-1",
  "cdr-button": "cdr-button_16-2-1",
  "cdr-button--has-icon-left": "cdr-button--has-icon-left_16-2-1",
  "cdr-button--has-icon-right": "cdr-button--has-icon-right_16-2-1",
  "cdr-button--primary": "cdr-button--primary_16-2-1",
  "cdr-button--secondary": "cdr-button--secondary_16-2-1",
  "cdr-button--dark": "cdr-button--dark_16-2-1",
  "cdr-button--sale": "cdr-button--sale_16-2-1",
  "cdr-button--link": "cdr-button--link_16-2-1",
  "cdr-button--large": "cdr-button--large_16-2-1",
  "cdr-button--medium": "cdr-button--medium_16-2-1",
  "cdr-button--small": "cdr-button--small_16-2-1",
  "cdr-button--icon-only": "cdr-button--icon-only_16-2-1",
  "cdr-button--icon-only-large": "cdr-button--icon-only-large_16-2-1",
  "cdr-button--with-background": "cdr-button--with-background_16-2-1",
  "cdr-button--full-width": "cdr-button--full-width_16-2-1",
  "cdr-button--small@xs": "cdr-button--small@xs_16-2-1",
  "cdr-button--medium@xs": "cdr-button--medium@xs_16-2-1",
  "cdr-button--large@xs": "cdr-button--large@xs_16-2-1",
  "cdr-button--full-width@xs": "cdr-button--full-width@xs_16-2-1",
  "cdr-button--small@sm": "cdr-button--small@sm_16-2-1",
  "cdr-button--medium@sm": "cdr-button--medium@sm_16-2-1",
  "cdr-button--large@sm": "cdr-button--large@sm_16-2-1",
  "cdr-button--full-width@sm": "cdr-button--full-width@sm_16-2-1",
  "cdr-button--small@md": "cdr-button--small@md_16-2-1",
  "cdr-button--medium@md": "cdr-button--medium@md_16-2-1",
  "cdr-button--large@md": "cdr-button--large@md_16-2-1",
  "cdr-button--full-width@md": "cdr-button--full-width@md_16-2-1",
  "cdr-button--small@lg": "cdr-button--small@lg_16-2-1",
  "cdr-button--medium@lg": "cdr-button--medium@lg_16-2-1",
  "cdr-button--large@lg": "cdr-button--large@lg_16-2-1",
  "cdr-button--full-width@lg": "cdr-button--full-width@lg_16-2-1",
  "cdr-icon": "cdr-icon_16-2-1",
  "cdr-icon--small": "cdr-icon--small_16-2-1",
  "cdr-icon--large": "cdr-icon--large_16-2-1",
  "cdr-icon--small@xs": "cdr-icon--small@xs_16-2-1",
  "cdr-icon--large@xs": "cdr-icon--large@xs_16-2-1",
  "cdr-icon--small@sm": "cdr-icon--small@sm_16-2-1",
  "cdr-icon--large@sm": "cdr-icon--large@sm_16-2-1",
  "cdr-icon--small@md": "cdr-icon--small@md_16-2-1",
  "cdr-icon--large@md": "cdr-icon--large@md_16-2-1",
  "cdr-icon--small@lg": "cdr-icon--small@lg_16-2-1",
  "cdr-icon--large@lg": "cdr-icon--large@lg_16-2-1",
  "cdr-icon--inherit-color": "cdr-icon--inherit-color_16-2-1",
  "cdr-popover--position": "cdr-popover--position_16-2-1",
  "cdr-popover--wrapper": "cdr-popover--wrapper_16-2-1",
  "cdr-popover__title": "cdr-popover__title_16-2-1",
  "cdr-popover__container": "cdr-popover__container_16-2-1",
  "cdr-popover__content": "cdr-popover__content_16-2-1",
  "cdr-popover__close-button": "cdr-popover__close-button_16-2-1"
};
export {
  r as default
};
